export let FigurePreviewBasicValue = {
  column: '',
  xType: '',
  records: 0,
  firstVal: '',
  uniqueVals: 0,
  avg: 0,
  var: 0,
  std: 0,
  min: 0,
  max: 0,
  med: 0,
  mod: 0,
  kurt: 0,
  skew: 0,
  info: {},
  transformable: 0,
  transformableTypes: [],
  use: false
}

export let FigurePreviewBasic = {
  header: [],
  value: null
}

export let FigurePreviewDistResult = {
  name: '',
  value: {
    order: [],
    count: [],
    value: [],
    yAvg: []
  }
}

export let FigurePreviewDist = {
  results: []
}

export let FigurePreviewXEval = {
  header: [],
  value: null
}

export let FigurePreviewAcfResult = {
  value: []
}

export let FigurePreviewAcf = {
  results: []
}

export let FigurePreviewPacfResult = {
  value: []
}

export let FigurePreviewPacf = {
  results: []
}

export let FigurePreview = {
  basic: FigurePreviewBasic,
  dist: FigurePreviewDist,
  xeval: FigurePreviewXEval,
  acf: FigurePreviewAcf,
  pacf: FigurePreviewPacf,
  AUC: null,
  Accuracy: null,
  FMeasure: null,
  KS: null,
  Lift: null
}

export let Figure = {
  figureId: '',
  dsName: '',
  yName: '',
  figures: {
    basic: '',
    dist: '',
    xeval: '',
    acf: '',
    pacf: ''
  },
  figurePreview: FigurePreview
}



// WEBPACK FOOTER //
// ./src/defines/model/figure.js